import React, {Component, useEffect, useState} from 'react';
import {
    Authenticator,
    useTheme,
    Text,
    View,
    Heading,
    ThemeProvider, useAuthenticator
} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import CustomVerifyContact from './CustomVerifyContact';
import {withRouter} from "react-router";
import _ from "lodash";
import CustomResetPassword from './CustomResetPassword';
import getOidcServiceInstance from "../eid/EIDOidcSingletonService";
import {toast} from "react-toastify";
import CognitoVerifyPasswordReset from "./CognitoVerifyPasswordReset";
import {API, Auth} from "aws-amplify";

function sanitizeReferrer(originalReferrer) {
    if (!originalReferrer) return '';

    try {
        // Parse the referrer URL
        const url = new URL(originalReferrer);
        const allowedHosts = ['app.cuehit-dev.com', 'app.stage.cuehit-dev.com','accounts.neogov.com','accounts.qa.powerdms.net','accounts.staging.neogov.net','accounts.staging.powerdms.net'];
        if (!allowedHosts.includes(url.hostname)) {
            return '';
        }

        url.search = '';
        url.hash = '';

        return url.toString();
    } catch (err) {
        // If parsing fails or the URL is invalid, return an empty string
        return '';
    }
}

const theme = {
    name: 'heading-theme',
    tokens: {
        components: {
            heading: {
                // color: { value: '{colors.blue.80}' },
                5: {
                    fontSize: {value: '{fontSizes.medium}'},
                    fontWeight: {value: '{fontWeights.normal}'},
                },

            },
        },
    },
};

function AuthComponent(props) {
    const services = {
        async handleSignIn(input) {
            let { username, password } = input;
            try {
                return await Auth.signIn(username, password);
            } catch (error) {
                if (error.code === 'UserNotFoundException')  {
                    const encodedUsername = encodeURIComponent(username);
                    const resp = await API.get("Unauthorized", `/u/${encodedUsername}/whoami`);
                    if (resp?.F === "P") {
                        const customError = new Error("PreAuthentication failed with error: Please login with your PowerDMS platform account.");
                        customError.code = error.code;
                        throw customError;
                    }
                else {
                    throw error;
                }

            }else {
                    throw error;
                }
            }
        },
    };
    useEffect(() => {
    // Only run client-side
        if (typeof document !== 'undefined') {
    // Capture the real referrer once
            const realRef = document.referrer;
            // Overwrite document.referrer with a sanitized version
            Object.defineProperty(document, 'referrer', {
                get: () => sanitizeReferrer(realRef),
                configurable: true
            });
        }
        document.querySelectorAll('form').forEach(form => {
            form.setAttribute('autocomplete', 'off');
        });
        const scrubAndLock = () => {
            const inputs = document.querySelectorAll('input[name="password"], input[name="username"]');
            inputs.forEach(input => {
                if (input.dataset.scrubbed) return;
                if (input.value) {
                    input.value = '';
                    input.setAttribute('value', '');
                }
                input.setAttribute('readonly', 'true');
                input.setAttribute(
                    'autocomplete',
                    input.name === 'password' ? 'new-password' : 'off'
                );
                input.addEventListener(
                    'focus',
                    () => input.removeAttribute('readonly'),
                    { once: true }
                );
                input.dataset.scrubbed = 'true';
            });
        };
        scrubAndLock();
        const t1 = setTimeout(scrubAndLock, 400);
        const t2 = setTimeout(scrubAndLock, 1200);
        const mo = new MutationObserver(scrubAndLock);
        mo.observe(document.body, { childList: true, subtree: true });

        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
            mo.disconnect();
        };
    }, []);

    var backgroundImageUrl = null;
    const [showResetPassword, setShowResetPassword] = useState(false);

    useEffect(() => {
        const logoutMessage = localStorage.getItem(`logout_message:${window.__RUNTIME_CONFIG__.API_HOST}`);
        localStorage.removeItem(`lastAppSwitcherConfig:${window.__RUNTIME_CONFIG__.API_HOST}`);
        if (logoutMessage) {
            toast(logoutMessage, {position: "top-center", type: "error"});
            localStorage.removeItem(`logout_message:${window.__RUNTIME_CONFIG__.API_HOST}`);
        }
    }, []);

    const components = {
        Footer() {
            const {tokens} = useTheme();

            return (
                <View textAlign="center" padding={tokens.space.large}>
                    <Text color={tokens.colors.neutral[80]}>
                        &copy; All Rights Reserved
                    </Text>
                </View>
            );
        },
        SignIn: {
            Header() {
                const {tokens} = useTheme();

                return (
                    <Heading
                        padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
                        level={5}
                    >
                        Sign in to your account
                    </Heading>
                );
            },
            Footer() {
                const {toResetPassword} = useAuthenticator();
                const isEidSignInEnabled = window.__RUNTIME_CONFIG__?.EID_SIGNIN_ENABLED === 'true';
                const handleEidSignIn = async () => {
                    const oidcInstance = await getOidcServiceInstance();
                    oidcInstance?.signIn();
                }
                const cognitoVerifyResetPassword = () => {
                    if (isEidSignInEnabled) {
                        setShowResetPassword(true);
                    } else {
                        toResetPassword();
                    }
                };

                return (
                    <div>
                        {isEidSignInEnabled && (
                            <button onClick={() => handleEidSignIn()} style={{
                                background: '#FF9900',
                                maxWidth: '300px',
                                textTransform: 'uppercase',
                                alignSelf: 'flex-end',
                                fontWeight: 100,
                                border: 'none',
                                padding: '10px 20px',
                                color: 'white',
                                fontFamily: 'Arial, sans-serif',
                                cursor: 'pointer',
                                textAlign: 'right',
                                display: 'block',
                                marginTop: '-20px',
                                marginLeft: '200px',
                                whiteSpace: 'nowrap',
                                borderRadius: '4px',
                            }}>Sign in with PowerDMS</button>)}

                        <View textAlign="left" style={{
                            display: 'flex',
                            paddingTop: isEidSignInEnabled ? '30px' : '0px',
                            paddingRight: '40px',
                            paddingBottom: '35px',
                            paddingLeft: '40px'
                        }}>
                            <p style={{fontSize: '12px'}}><span style={{color: '#828282'}}>Forgot you password?</span>
                                <span onClick={() => cognitoVerifyResetPassword()}
                                      style={{color: '#FF9900', cursor: 'pointer'}}>Reset password</span></p>
                        </View>
                    </div>
                );
            },
        },
        ResetPassword: {
            Header() {
                return (
                    <Heading level={5}>
                        Reset password
                    </Heading>
                );
            },
        }
    };

    const formFields = {
        signIn: {
            username: {
                placeholder: 'Email*',
                isRequired: true,
                labelHidden: true,
                autocomplete: 'off'
            },
            password: {
                placeholder: 'Password*',
                isRequired: true,
                labelHidden: true,
                hideShowPassword: false,
                autocomplete: 'new-password'
            }
        },
        confirmResetPassword: {
            confirmation_code: {
                placeholder: 'Code',
                isRequired: true,
                labelHidden: true,
                autocomplete: 'one-time-code'
            },
            password: {
                placeholder: 'New Password',
                isRequired: true,
                labelHidden: true,
                autocomplete: 'new-password'
            },
            confirm_password: {
                placeholder: 'Confirm Password',
                isRequired: true,
                labelHidden: true,
                autocomplete: 'new-password'
            },
        },
        resetPassword: {
            username: {
                placeholder: 'Email*',
                isRequired: true,
                labelHidden: true,
                autocomplete: 'off'
            }
        }
    };
    if (_.has(props, 'user.aboutMe.user') && props.user.aboutMe.user.lightTheme) {
        backgroundImageUrl = '/powerdms-engage-FKA-logo.svg';
    } else {
        backgroundImageUrl = '/powerdms-engage-FKA-logo-white.svg';
    }

    let logo = (<div style={{
        backgroundImage: `url("${backgroundImageUrl}")`,
        backgroundSize: '280px 80px',
        width: '280px',
        height: '80px'
    }} className="logo"></div>);

    return (
        <div className="gatekeeperView logIn">
            <div className="gatekeeperContentView">
                <a href="https://www.powerdms.com/power-engage" data-testid="signedInPlaceholderLogo">{logo}</a>
                <ThemeProvider theme={theme}>
                    {!showResetPassword ? (
                            <Authenticator
                                loginMechanisms={['email']}
                                // authData={props.childProps.authenticatedUser}
                                hideSignUp={true}
                                components={components}
                                services={services}
                                formFields={formFields}>
                                <VerificationListener calculatedAuthState={props.childProps} {...props} />
                                <CustomVerifyContact override={'verifyContact'}/>
                                <CustomResetPassword override={'forgotPassword'} {...props} />

                                {/*
                        <ConfirmSignIn />
                        <RequireNewPassword />
                        <ConfirmSignUp />
                        <TOTPSetup />

                        */}

                            </Authenticator>) :
                        <CognitoVerifyPasswordReset setShowResetPassword={setShowResetPassword} {...props}/>}
                </ThemeProvider>
            </div>
        </div>
    );
}

class VerificationListener extends Component {
    componentDidUpdate() {
        let currentPath = _.trimStart(this.props.location.pathname, "/");
        // Sidebar shouldn't show unless logged in
        if (_.startsWith(currentPath, 'sign-up') && this.props.authState === "signIn") {
            this.props.onStateChange('signUp', this.props.authData);
        } else if (this.props.calculatedAuthState.isAuthenticated && this.props.calculatedAuthState.needsVerification) {
            this.props.onStateChange('verifyContact', this.props.authData);
        }
    }

    render() {
        return null;
    }

}

export default withRouter(AuthComponent);
